import { BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { enqueueSnackbar } from 'notistack';
import { refreshExpiredFunc } from '../store/slices/refreshExpiredReducer';
import { globalVal } from '../app/common/ConstantColors';
import { errorMsgs } from '../utils/error-msgs';

const baseQuery = fetchBaseQuery({
  baseUrl: (process.env.REACT_APP_API_ADDRESS || "https://testmanagementapi.ahlpay.com.tr").replace(/\/$/, ""),
  prepareHeaders: (headers) => {
    let token = localStorage.getItem('accessToken');
    if (!token) {
      token = localStorage.getItem('verifyToken');
    } else {
      localStorage.removeItem('verifyToken');
    }
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

export const baseQueryWithReauth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
  if (globalVal.isLoggedOut) {
    // Eğer kullanıcı çıkış yapmışsa, tüm istekleri durduruyoruz.
    return { error: { status: 401, data: { message: 'Oturum kapalı, tekrar giriş yapın.' } } };
  }

  // baseUrl'e path olmadan (sadece root) istek gitmesini engelle – backend hataya sebep oluyor
  const url = typeof args === 'string' ? args : (args as FetchArgs).url;
  if (url === "" || url === "/") {
    console.warn("[dataSlice] API isteği boş veya sadece '/' path ile yapıldı – istek iptal edildi.", { url, args });
    return { error: { status: 400, data: { message: 'Geçersiz API path: url boş veya sadece "/" olamaz.' } } };
  }

  try {
    let result: any = await baseQuery(args, api, extraOptions);
    api.dispatch(refreshExpiredFunc())
    //console.log('api', api.getState()?.login.isAuthenticated)
    if (result.data && result.data.data?.token) {
      let getSession = localStorage.getItem('accessToken');
      if (getSession)
        localStorage.setItem('accessToken', result.data.data.token);
      else
        localStorage.setItem('verifyToken', result.data.data.token);
    }
    if (result.error) {
      if (result.error?.data?.message && result.error?.status !== 401) {
        if (result.error?.data?.message && Array.isArray(result.error.data.message)) {
          const formattedMessage = result.error.data.message.join(', ');
          enqueueSnackbar(formattedMessage, { variant: 'error' });
        } else {
          if (result.error?.status === 404) {
            // burası appsettings ayarları için yazılmış bir condition
            // 404 kayıt yok demek bunun için hata mesaji dönme epin için yapıldı bu condition.
            return;
          }
          enqueueSnackbar(result.error?.data?.message, { variant: 'error' });
        }
      } else {
        if (!globalVal.isLoggedOut) {
          enqueueSnackbar(errorMsgs(result.error?.status, api), { variant: 'error' });
        }
        if (result.error?.status === 401) {
          globalVal.isLoggedOut = true; // Çıkış yapılmış durumu işaretle
        }
        // 500 hatası alındığında bir önceki sayfaya dönme
        /* if (result.error?.status === 500) {
          window.history.back();
        } */
      }
    }
    return result;
  } catch (error: any) {
    if (error?.name === 'AbortError') {
      enqueueSnackbar('İstek zaman aşımına uğradı', { variant: 'error' });
    } else {
      // Diğer hataları burada yakala
    }
  } finally {
  }
};

